import { confirmationOfRecord, errorActions } from "@/alerts";
import axios from "../../../api";
/**
 * Funcion para insertar una venta
 * @param {*} data Los datos principales de la venta
 * @param {*} details Los detalles de la venta
 * @param {*} dataCustomer Los datos del cliente
 * @param {*} insurerData Los datos de la aseguradora
 * @param {*} orderQuotesTemporarySalesInfo el id de cotizaciones, pedidos y ventas temporales
 * @param {*} creditNote biene la informacion de la nota de credito cuando se aplica a una venta
 * @returns El id de la venta registrada
 */
export const insertSale = async (data, details,dataCustomer,insurerData,orderQuotesTemporarySalesInfo, creditNote) => {
  const {
    idUser,
    idStore,
    idTurn,
    idVoucher,
    idTypeOfSale,
    idTypeOfPayment,
    idCreditNote,
    total,
    totalWhitDiscount,
    igv,
    subTotal,
    otherDiscounts,
    totalCreditNote,
    totalCreditNoteDiference,
    discount,
    expireQuotation,
    comentary,
    totalPayableByInsurer,
    totalPayableByCustomer,
    userName,
    customerName,
    serieVoucher,
    numberVoucher,
    numberReference,
    currencyDescription,
    currencyPrefix,
    igvApplied,
    retention,
    entityBank,
    numberOperation,
    cashAmount,
    targetAmount,
    transferAmount,
    chequeAmount,
    customerAmountPaid,
    customerAmountReturned,
    modificationDate,
    sunatAnswer,
    paymentDate,
    initialFee,
    idCharge,
    nameCharge,
  } = data;
  try {
    const response = await axios.post(
      "ventas",
      {
        idUser,
        idStore,
        idTurn,
        idVoucher,
        idTypeOfSale,
        idTypeOfPayment,
        idCreditNote,
        total,
        totalWhitDiscount,
        igv,
        subTotal,
        otherDiscounts,
        totalCreditNote,
        totalCreditNoteDiference,
        discount,
        expireQuotation,
        comentary,
        totalPayableByInsurer,
        totalPayableByCustomer,
        userName,
        customerName,
        serieVoucher,
        numberVoucher,
        numberReference,
        currencyDescription,
        currencyPrefix,
        igvApplied,
        retention,
        entityBank,
        numberOperation,
        cashAmount,
        targetAmount,
        transferAmount,
        chequeAmount,
        customerAmountPaid,
        customerAmountReturned,
        modificationDate,
        sunatAnswer,
        state:idTypeOfSale==2?'VENTA A CREDITO':'EFECTUADA',
        idCustomer: dataCustomer.id,
        paymentDate,
        initialFee,
        idInsurer: insurerData.id,
        idOrder: orderQuotesTemporarySalesInfo.id,
        amountCreditNote: creditNote.amount,
        idCharge,
        nameCharge,
        details
      },
      {
        method: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.data;
    if (data.msg === true) {
      confirmationOfRecord(
        `La venta del cliente <strong>${customerName}</strong>`
      );
      return data.id;
    } else {
        errorActions(`Lo sentimos no pudimos registrar la venta del cliente <strong>${customerName}</strong> verifica si tuviste alguna problemas al momento de ingresar los productos o los datos del cliente`)
    }
    return 0
  } catch (error) {
    errorActions(error);
    return 0
  }
};
